import usePutTableSettings from './usePutTableSettings';
import useTableSettings from './useTableSettings';

export { usePutTableSettings, useTableSettings };
